import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TrailingSlashNormalizer = (): null => {
    const { pathname, search, hash } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const hasMultipleSlashes = /\/\//.test(pathname);
        const hasTrailingSlash = pathname.length > 1 && pathname.endsWith('/');

        if (hasMultipleSlashes || hasTrailingSlash) {
            const cleaned = '/' + pathname.split('/').filter(Boolean).join('/');
            if (cleaned !== pathname) navigate(cleaned + search + hash, { replace: true });
        }
    }, [pathname, search, hash, navigate]);

    return null;
};

export default TrailingSlashNormalizer;